import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sl22',
  templateUrl: './sl22.component.html',
  styleUrls: ['./sl22.component.scss']
})
export class Sl22Component {
  
    @Input() package: any;
    @Output() link = new EventEmitter<string>();
  
    emitLink(link: string): void {
      this.link.emit(link);
    }
}
